<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ this.patID }} - {{ this.patName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card v-if="this.requestError == true && this.loading != true">
      <v-card-text>
        <v-row>
          <v-col>
            <v-alert type="error">Error getting Patient MLR details.</v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      v-else
      :loading="load"
      :headers="headers"
      :items="pat_data"
      :search="search"
      :sort-desc="[true]"
      :footer-props="{
        'items-per-page-options': [12, 24, 36, 48, -1]
      }"
      :items-per-page="12"
      loading-text="Loading data..."
      class="elevation-0 rounded-0 px-2"
      :sort-by="['_id']"
    >
      <template v-slot:item.MLR="{ item }">
        {{ item.MLR ? item.MLR.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + "%" : "-" }}
      </template>

      <template v-slot:item.MRA="{ item }">
        {{ item.MRA ? item.MRA.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") : "N/A" }}
      </template>

      <template v-slot:item.TOT_EXPENSE="{ item }">
        {{
          item.TOT_EXPENSE
            ? "$" + item.TOT_EXPENSE.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
            : "$0.00"
        }}
      </template>

      <template v-slot:item.TOT_REVENUE="{ item }">
        {{
          item.TOT_REVENUE
            ? "$" + item.TOT_REVENUE.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
            : "$0.00"
        }}
      </template>

      <template slot="body.append">
        <tr class="subtitle-2 primary--text">
          <td class="font-weight-bold">Totals:</td>
          <td class="font-weight-bold">
            ${{ this.totalRevenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") }}
          </td>
          <td class="font-weight-bold">
            ${{ this.totalExpense.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") }}
          </td>
          <td></td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PatientMlrDetails',
  props: [
    'value',
    'insurance',
    'patID',
    'patName',
    'startDate',
    'endDate',
    'groups',
    'providers',
    'locations',
  ],
  data() {
    return {
      search: '',
      load: false,
      headers: [
        { text: 'Month', value: 'month' },
        { text: 'Revenue', value: 'TOT_REVENUE' },
        { text: 'Expenses', value: 'TOT_EXPENSE' },
        { text: 'MRA', value: 'MRA' },
        { text: 'MLR', value: 'MLR' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      pat_data: [],
      totalRevenue: 0,
      totalExpense: 0,
    };
  },
  methods: {
    async getPatData() {
      this.load = true;
      this.requestError = false;
      this.pat_data = [];

      let allprovs = [];
      let alllocs = [];

      this.totalRevenue = 0;
      this.totalExpense = 0;

      if (this.providers.length > 0) {
        this.providers.forEach((prov) => {
          if (allprovs.indexOf(prov.Center_PCP_Number) === -1) {
            allprovs.push(prov.Center_PCP_Number);
          }
        });
      } else {
        allprovs = [];
      }

      if (this.locations.length > 0) {
        this.locations.forEach((loca) => {
          if (alllocs.indexOf(loca.Center_Location) === -1) {
            alllocs.push(loca.Center_Location);
          }
        });
      } else {
        alllocs = [];
      }

      const response = axios
        .get(
          `/api/modal/mlrdetails/patients/groups=${this.groups}/providers=${allprovs}/locations=${alllocs}/${this.insurance}/${this.patID}/${this.startDate}/${this.endDate}`,
        )
        .then((response) => {
          this.pat_data = response.data.data;
          this.totalRevenue = response.data.revenue;
          this.totalExpense = response.data.expense;
          this.load = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.load = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async patID() {
      if (this.patID != null && this.patID != 0 && this.patID != '') {
        this.getPatData();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
